<script lang="ts">
  import VerticalCenter from './verticalCenter.svelte';
  import Check from './check.svelte';

  export let title: string;
</script>

<VerticalCenter>
  <div>
    <Check />
    <h1>{title}</h1>
  </div>
</VerticalCenter>

<style>
  h1 {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin: 15px 0px 0px 0px;
  }
</style>
